import { Route, Routes } from "react-router-dom";
import { Home, Play } from "pages";
import { ProtectedRoute } from "./protected.route";
import { InviteFriend } from "pages/InviteFriend";
import { ComingSoon } from "pages/Coming-Soon";
import { Mining } from "pages/Mining";
import { ROUTES } from "./config";

export function BaseRoute() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route
        path={ROUTES.play}
        element={
          <ProtectedRoute>
            <Play />
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.invite}
        element={
          <ProtectedRoute>
            <InviteFriend />
          </ProtectedRoute>
        }
      />

      <Route
        path={ROUTES.mining}
        element={<Mining />}
      />

      <Route path={ROUTES.comingSoon} element={<ComingSoon />} />
    </Routes>
  );
}
